import { getTeamsByBookingId } from "@/api/gql/teams";
import {
  BookingTeamsStatus,
  ITeam,
  ITeamSetting,
  TeamLevel,
} from "@/interfaces/teams/teams";
import BookingModule from "@/store/modules/booking";
import { BookingStatus } from "@/types/db/product-slot-state";
import { sumArray } from "./common";

/**
 * this function fetches all the teams related to the current booking
 * @returns array of ITeam
 */
export async function fetchBookingTeams(bookingId: number): Promise<ITeam[]> {
  const res = await getTeamsByBookingId(bookingId);
  if (!res || !res.length) return [];
  const teams: ITeam[] = [];
  for (let i = 0; i < res.length; i++) {
    if (res[i]?.cancelled !== 0) continue;
    const teamObj = res[i];
    teams.push({
      uuid: String(teamObj?.uuid),
      bookingId: Number(teamObj?.bookingId),
      name: teamObj?.name || "",
      roomPlayers: Number(teamObj?.roomPlayers),
      startDateTime: teamObj?.startDateTime || "",
      endDateTime: teamObj?.endDateTime || "",
      nfcTag: teamObj?.nfcTag || "",
      paired: true,
      ticketUuids: [],
      teamLevel: teamObj?.teamLevel || TeamLevel.MEDIUM,
    });
  }
  return teams;
}

/**
 * this function returns the status of the booking teams
 * @returns BookingTeamsStatus
 */
export async function getBookingTeamsStatus(
  bookingId: number,
  teamsSettings: ITeamSetting[]
): Promise<BookingTeamsStatus> {
  const teams = await fetchBookingTeams(bookingId);
  if (!teams || !teams.length) {
    // booking require teams but doesn't have any
    return BookingTeamsStatus.NotStarted;
  }
  const countedPricesIds = teamsSettings.map((s) => s.countedPsp).flat();
  const pssList = BookingModule.selectedBooking?.pssList || [];
  const countedTickets = pssList.filter(
    (pss) =>
      pss.bookingStatus !== BookingStatus.Canceled &&
      pss.bookingStatus !== BookingStatus.Abandoned &&
      countedPricesIds.includes(pss.priceId)
  ).length;
  const totalPlayers = sumArray(teams.map((t) => t.roomPlayers));
  if (countedTickets > totalPlayers) {
    // booking require teams but not all teams were created
    return BookingTeamsStatus.InProgress;
  }
  return BookingTeamsStatus.Completed;
}
